import React from 'react';
import styled from 'styled-components';
import { GAME_CONFIG } from '../config/gameConfig';
import { RHYTHM_CONFIG } from '../config/RhythmConfig';

const LaneContainer = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  pointer-events: none;
  touch-action: none;
  overscroll-behavior: none;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 20px;
  
  @media (max-width: 768px) {
    top: 50px;
    height: calc(100% - 50px);
  }
`;

const Lane = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  pointer-events: auto;
  touch-action: none;
  overscroll-behavior: none;
  -webkit-user-select: none;
  user-select: none;
  min-height: 100%;
  cursor: pointer;
  
  &:last-child {
    border-right: none;
  }
`;

const KeyLabel = styled.div`
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 1.2rem;
  opacity: 0.5;
  pointer-events: none;
  @media (pointer: coarse) {
    display: none;
  }
  
  @media (max-width: 768px) {
    font-size: 1rem;
    bottom: 60px;
  }
`;

const RhythmLanes = ({
  activeLanes,
  handleLanePress,
  handleLaneRelease,
  handleLaneCancel,
  rhythmConfig = RHYTHM_CONFIG
}) => {
  const keyLabels = rhythmConfig.KEY_LABELS;
  const renderLanes = () => Array.from({ length: 4 }, (_, index) => (
    <Lane
      key={index}
      onPointerDown={handleLanePress(index)}
      onPointerUp={handleLaneRelease(index)}
      onPointerCancel={handleLaneCancel(index)}
      style={{
        backgroundColor: activeLanes.has(index) ? 'rgba(255,255,255,0.12)' : 'transparent',
      }}
    >
      <KeyLabel>{keyLabels[index]}</KeyLabel>
    </Lane>
  ));

  return (
    <LaneContainer>
      {renderLanes()}
    </LaneContainer>
  );
};

export default RhythmLanes;
